import React from 'react';
import { Modal, IconButton, Button, Icon } from '@hevoio/hevo-ui-toolkit';
import { IconX, IconRoute } from '@tabler/icons-react';
import useAnalyticsTracker from '../../../../../analytics/hooks/useAnalyticsTracker';
import { PipelineListTrackers } from '../../../tracking/pipeline-list-trackers';
import { ACCOUNT_EXEC_SCHEDULE_CALL_LINK } from '../../../../../core/constants/constants';

interface ScheduleDemoModalProps {
  open: boolean;
  onClose: () => void;
}

export function ScheduleDemoModal({ open, onClose }: ScheduleDemoModalProps) {
  const { eventTrack } = useAnalyticsTracker();

  const handleCTAClick = () => {
    eventTrack({
      action: PipelineListTrackers.PIPELINE_TRACKER_SCHEDULE_DEMO_POPUP_CTA_CLICK
    });
    window.open(ACCOUNT_EXEC_SCHEDULE_CALL_LINK, '_blank', 'noopener');
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <>
        <div className='dialog-header'>
          <div className='center-flex-row'>
            <IconRoute size={24} className='mr-3' />
            <span className='text-label-small'>Still haven't created your first Pipeline?</span>
          </div>
          <IconButton label='Close' dataId='schedule-demo-close' onClick={onClose}>
            <IconX size={20} />
          </IconButton>
        </div>

        <div className='dialog-body px-6 py-5'>
          <p className='text-secondary'>
            Our engineer will walk you through it. Most Pipelines are up and running in under 15 minutes.
          </p>

          <div className='d-flex justify-end mt-7'>
            <Button
              dataId='schedule-demo-dismiss'
              variation='outline'
              onClick={onClose}
            >
              Set it up myself
            </Button>
            <Button
              dataId='schedule-demo-cta'
              className='ml-3'
              onClick={handleCTAClick}
            >
              Schedule a Demo
            </Button>
          </div>
        </div>
      </>
    </Modal>
  );
}
